import { FETCH_AGENTS_SUCCESS } from 'constants/action_types'

export default function successAction(res) {
  const data = res.json.data
  return { type: FETCH_AGENTS_SUCCESS, data: { ...data } }
}
